// Module
var code = `<table class="table">
  <tr>
    <td>Print name:</td>
    <td>{{\$ctrl.printName}}</td>
  </tr>
  <tr>
    <td>Organization:</td>
    <td>{{\$ctrl.branch.organization.name}}</td>
  </tr>
  <tr>
    <td>Branch name:</td>
    <td>{{\$ctrl.branch.name}}</td>
  </tr>
  <tr>
    <td>Branch address:</td>
    <td>{{\$ctrl.branch.address.street}} {{\$ctrl.branch.address.city}}</td>
  </tr>
  <tr>
    <td>Generated on:</td>
    <td>{{\$ctrl.time | prettyDateTime}}</td>
  </tr>
  <tr>
    <td>Generated by:</td>
    <td>{{\$ctrl.user.fullName}}</td>
  </tr>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/print-header/print-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;